import format from "date-fns-tz/format";
import { getTrackThumbnailPath, Track } from "model/Track/Track";
import { useState } from "react";
import { shallowEqual } from "react-redux";
import { selectTrackFeatureDetails } from "selectors/Track";
import {
  DesktopSpan,
  DesktopTmioButton,
  MobileSpan,
  MobileTmioButton,
  TrackHeaderBodyContainer,
  TrackHeaderContainer,
  TrackHeaderNameRow,
  TrackHeaderStatsContainer,
  TrackHeaderStatsRow,
  TrackImage,
  TrackImageContainer,
  TrackName,
} from "./styles";
import { useAppSelector } from "app/hooks";

interface Props {
  track: Track;
}
const FEATURED_DATE_FORMAT = "MMMM do, yyyy";
const FEATURED_DATE_FORMAT_MOBILE = "MMM yyyy";

export const TrackHeader = ({ track }: Props) => {
  // const { time: liveRecord, driverIds: liveRecordDriverIds } = useAppSelector(
  //   (state) => selectTrackLiveRecordWithDriverIds(state, track.id),
  //   (a, b) => a.time === b.time && shallowEqual(a.driverIds, b.driverIds) // todo - custom equal functions for types?
  // );

  // const liveRecordDriverNames = useAppSelector(
  //   (state) =>
  //     nonUndefined(
  //       liveRecordDriverIds.map((id) =>
  //         selectTournamentDriverName(state, id, tournamentId)
  //       )
  //     ),
  //   shallowEqual
  // );

  const {
    tournamentsCount,
    matchesCount,
    firstFeaturedName,
    firstFeaturedTrigram,
    firstFeaturedStartTimeMs,
    lastFeaturedName,
    lastFeaturedTrigram,
    lastFeaturedEndTimeMs,
  } = useAppSelector(
    (state) => selectTrackFeatureDetails(state, track.id),
    shallowEqual
  );

  const firstFeaturedDate = !!firstFeaturedStartTimeMs
    ? format(new Date(firstFeaturedStartTimeMs), FEATURED_DATE_FORMAT)
    : undefined;
  const firstFeaturedDateMobile = !!firstFeaturedStartTimeMs
    ? format(new Date(firstFeaturedStartTimeMs), FEATURED_DATE_FORMAT_MOBILE)
    : undefined;

  const lastFeaturedDate = !!lastFeaturedEndTimeMs
    ? format(new Date(lastFeaturedEndTimeMs), FEATURED_DATE_FORMAT)
    : undefined;
  const lastFeaturedDateMobile = !!lastFeaturedEndTimeMs
    ? format(new Date(lastFeaturedEndTimeMs), FEATURED_DATE_FORMAT_MOBILE)
    : undefined;

  const trackThumbnailPath = getTrackThumbnailPath(track);
  const [imgSrc, setImgSrc] = useState(trackThumbnailPath);

  return (
    <TrackHeaderContainer>
      <TrackImageContainer>
        <TrackImage
          src={imgSrc}
          onError={() => setImgSrc(`/images/orgs/default/logo.png`)}
        />
        {!!track.link && (
          <MobileTmioButton href={track.link} target="_blank">
            View on TM.io
          </MobileTmioButton>
        )}
      </TrackImageContainer>
      <TrackHeaderBodyContainer>
        <TrackHeaderNameRow>
          <TrackName>{track.name}</TrackName>
          {!!track.link && (
            <DesktopTmioButton href={track.link} target="_blank">
              View on TrackMania.io
            </DesktopTmioButton>
          )}
        </TrackHeaderNameRow>
        <TrackHeaderStatsContainer>
          {/* <TrackHeaderStatsRow>
            <span>
              Live Record:{" "}
              {liveRecord !== undefined
                ? `${convertMsToTimeString(
                    Math.round(liveRecord)
                  )} by ${liveRecordDriverNames.join(", ")}`
                : "-"}
            </span>
          </TrackHeaderStatsRow> */}
          <TrackHeaderStatsRow>
            <span>Tournaments Count: {tournamentsCount}</span>
            <span>Matches Count: {matchesCount}</span>
          </TrackHeaderStatsRow>
          <TrackHeaderStatsRow>
            <DesktopSpan>
              First Featured:{" "}
              {firstFeaturedName !== undefined
                ? `${firstFeaturedName} - ${firstFeaturedDate}`
                : "-"}
            </DesktopSpan>
            <MobileSpan>
              First Seen:{" "}
              {firstFeaturedTrigram !== undefined
                ? `${firstFeaturedTrigram}, ${firstFeaturedDateMobile}`
                : "-"}
            </MobileSpan>
          </TrackHeaderStatsRow>
          <TrackHeaderStatsRow>
            <DesktopSpan>
              Last Featured:{" "}
              {lastFeaturedName !== undefined
                ? `${lastFeaturedName} - ${lastFeaturedDate}`
                : "-"}
            </DesktopSpan>
            <MobileSpan>
              Last Seen:{" "}
              {lastFeaturedTrigram !== undefined
                ? `${lastFeaturedTrigram}, ${lastFeaturedDateMobile}`
                : "-"}
            </MobileSpan>
          </TrackHeaderStatsRow>
        </TrackHeaderStatsContainer>
      </TrackHeaderBodyContainer>
    </TrackHeaderContainer>
  );
};
